export default __webpack_public_path__ + "static/media/tiny2.65fb5a23.jpg";